<template>
    <div>
        <div class='mcf-page-background'></div>
        <div class="mcf-page-editor">
            <div class="mcf-page-editor-form">
                <div class="mcf-page-editor-header">
                    <label>Modifier les informations du client</label>
                </div>
                <div class="mcf-page-editor-menu">
                    <button @click="bt_save">
                        <i class="fa fa-save"></i>
                        <label>Enregistrer</label>
                    </button>
                    <button @click="set_copy_addresses">
                        <i class="fa fa-copy"></i>
                        <label>Copier les adresses</label>
                    </button>
                    <button @click="bt_cancel">
                        <i class="fa fa-close"></i>
                        <label>Annuler</label>
                    </button>
                </div>
                <div class="mcf-page-editor-content">
                    <div class="mcf-page-editor-title">
                        <label><i class='fa fa-circle-info'></i> Informations générales</label>
                    </div>
                    <div class="mcf-page-editor-line-2">
                        <div class="mcf-page-editor-column-text">
                            <label>Raison sociale</label>
                            <input type="text" v-model="cust.company" placeholder="Raison sociale">
                        </div>
                        <div class="mcf-page-editor-column-text">
                            <label>Rue principale</label>
                            <input type="text" v-model="cust.address1" placeholder="Adresse">
                        </div>
                    </div>
                    <div class="mcf-page-editor-line-2">
                        <div class="mcf-page-editor-column-text">
                            <label>Etage, ...</label>
                            <input type="text" v-model="cust.address2" placeholder="Adresse 2">
                        </div>
                        <div class="mcf-page-editor-column-text">
                            <label>Adresse complémentaire</label>
                            <input type="text" v-model="cust.address3" placeholder="Adresse 3">
                        </div>
                    </div>
                    <div class="mcf-page-editor-line-2">
                        <div class="mcf-page-editor-column-text">
                            <label>Code postal</label>
                            <input type="text" v-model="cust.zipcode" placeholder="Code postal">
                        </div>
                        <div class="mcf-page-editor-column-text">
                            <label>Ville</label>
                            <input type="text" v-model="cust.city" placeholder="Ville">
                        </div>
                    </div>
                    <div class="mcf-page-editor-line-2">
                        <div class="mcf-page-editor-column-text">
                            <label>Pays</label>
                            <input type="text" v-model="cust.country" placeholder="Pays">
                        </div>
                        <div class="mcf-page-editor-column-text">
                            <label>Téléphone</label>
                            <input type="text" v-model="cust.phone" placeholder="Téléphone">
                        </div>
                    </div>
                    <div class="mcf-page-editor-line-2">
                        <div class="mcf-page-editor-column-text">
                            <label>Courriel</label>
                            <input type="text" v-model="cust.email" placeholder="Courriel">
                        </div>
                        <div class="mcf-page-editor-column-text">
                            <label>Site web</label>
                            <input type="text" v-model="cust.website" placeholder="Site web">
                        </div>
                    </div>
                    <div class="mcf-page-editor-title">
                        <label><i class='fa fa-map-marker-alt'></i> Adresses</label>
                    </div>
                    <div class="mcf-page-editor-line-2">
                        <div class="mcf-page-editor-column-text">
                            <label>Adresse de facturation</label>
                        </div>
                        <div class="mcf-page-editor-column-text">
                            <label>Adresse de livraison</label>
                        </div>
                    </div>
                    <div class="mcf-page-editor-line-2">
                        <div class="mcf-page-editor-column-text">
                            <label>Raison sociale</label>
                            <input type="text" v-model="cust.billingcompany" placeholder="Raison sociale">
                        </div>
                        <div class="mcf-page-editor-column-text">
                            <label>Raison sociale</label>
                            <input type="text" v-model="cust.deliverycompany" placeholder="Raison sociale">
                        </div>
                    </div>
                    <div class="mcf-page-editor-line-2">
                        <div class="mcf-page-editor-column-text">
                            <label>Adresse</label>
                            <input type="text" v-model="cust.billingaddress1" placeholder="Adresse">
                        </div>
                        <div class="mcf-page-editor-column-text">
                            <label>Adresse</label>
                            <input type="text" v-model="cust.deliveryaddress1" placeholder="Adresse">
                        </div>
                    </div>
                    <div class="mcf-page-editor-line-2">
                        <div class="mcf-page-editor-column-text">
                            <label>Adresse 2</label>
                            <input type="text" v-model="cust.billingaddress2" placeholder="Adresse 2">
                        </div>
                        <div class="mcf-page-editor-column-text">
                            <label>Adresse 2</label>
                            <input type="text" v-model="cust.deliveryaddress2" placeholder="Adresse 2">
                        </div>
                    </div>
                    <div class="mcf-page-editor-line-2">
                        <div class="mcf-page-editor-column-text">
                            <label>Adresse 3</label>
                            <input type="text" v-model="cust.billingaddress3" placeholder="Adresse 3">
                        </div>
                        <div class="mcf-page-editor-column-text">
                            <label>Adresse 3</label>
                            <input type="text" v-model="cust.deliveryaddress3" placeholder="Adresse 3">
                        </div>
                    </div>
                    <div class="mcf-page-editor-line-2">
                        <div class="mcf-page-editor-column-text">
                            <label>Code postal</label>
                            <input type="text" v-model="cust.billingzipcode" placeholder="Code postal">
                        </div>
                        <div class="mcf-page-editor-column-text">
                            <label>Code postal</label>
                            <input type="text" v-model="cust.deliveryzipcode" placeholder="Code postal">
                        </div>
                    </div>
                    <div class="mcf-page-editor-line-2">
                        <div class="mcf-page-editor-column-text">
                            <label>Ville</label>
                            <input type="text" v-model="cust.billingcity" placeholder="Ville">
                        </div>
                        <div class="mcf-page-editor-column-text">
                            <label>Ville</label>
                            <input type="text" v-model="cust.deliverycity" placeholder="Ville">
                        </div>
                    </div>
                    <div class="mcf-page-editor-line-2">
                        <div class="mcf-page-editor-column-text">
                            <label>Pays</label>
                            <input type="text" v-model="cust.billingcountry" placeholder="Pays">
                        </div>
                        <div class="mcf-page-editor-column-text">
                            <label>Pays</label>
                            <input type="text" v-model="cust.deliverycountry" placeholder="Pays">
                        </div>
                    </div>
                    <div class="mcf-page-editor-line-2">
                        <div class="mcf-page-editor-column-text">
                            <label>Téléphone</label>
                            <input type="text" v-model="cust.billingphone" placeholder="Téléphone">
                        </div>
                        <div class="mcf-page-editor-column-text">
                            <label>Téléphone</label>
                            <input type="text" v-model="cust.deliveryphone" placeholder="Téléphone">
                        </div>
                    </div>
                    <div class="mcf-page-editor-title">
                        <label><i class='fa fa-circle-info'></i> Conditions de règlement</label>
                    </div>
                    <div class="mcf-page-editor-line-2">
                        <div class="mcf-page-editor-column-select">
                            <label>Type de règlement</label>
                            <select v-model="cust.terms_condition">
                                <option v-for="p of cust.lists.paymentstypes" :key="p.label" :value="p.label">{{p.label}}</option>
                            </select>
                        </div>
                        <div class="mcf-page-editor-column-select" v-if="cust.terms_delay=='TERM_RECEIPT'">
                            <label>Délais</label>
                            <select v-model="cust.terms_delay">
                                <option value="TERM_NETDAY">jours nets</option>
                                <option value="TERM_ENDOFMONTHTO">jours fin de mois le</option>
                                <option value="TERM_ENDOFMONTH">jours fin de mois</option>
                                <option value="TERM_RECEIPT">à réception de facture</option>
                            </select>
                        </div>
                    </div>
                    <div class="mcf-page-editor-line-3" v-if="cust.terms_delay!='TERM_RECEIPT'">
                        <div class="mcf-page-editor-column-text">
                            <label>Nombre de jours</label>
                            <input type="number" v-model="cust.terms_nb" placeholder="Nombre de jours">
                        </div>
                        <div class="mcf-page-editor-column-select">
                            <label>Délais</label>
                            <select v-model="cust.terms_delay">
                                <option value="TERM_NETDAY">jours nets</option>
                                <option value="TERM_ENDOFMONTHTO">jours fin de mois le</option>
                                <option value="TERM_ENDOFMONTH">jours fin de mois</option>
                                <option value="TERM_RECEIPT">à réception de facture</option>
                            </select>
                        </div>
                        <div class="mcf-page-editor-column-text" v-if="cust.terms_delay=='TERM_ENDOFMONTHTO'">
                            <label>Jour d'échéance</label>
                            <input type="number" v-model="cust.terms_day_due" placeholder="Jour d'échéance">
                        </div>
                    </div>
                    <div class="mcf-page-editor-title">
                        <label><i class='fa fa-circle-info'></i> Comptabilité</label>
                    </div>
                    <div class="mcf-page-editor-line-2">
                        <div class="mcf-page-editor-column-text">
                            <label>Numéro de SIRET</label>
                            <input type="text" v-model="cust.siret" placeholder="Numéro de SIRET">
                        </div>
                        <div class="mcf-page-editor-column-text">
                            <label>Code APE</label>
                            <input type="text" v-model="cust.ape_code" placeholder="Code APE">
                        </div>
                    </div>
                    <div class="mcf-page-editor-line-2">
                        <div class="mcf-page-editor-column-text">
                            <label>Numéro TVA Intracommunautaire</label>
                            <input type="text" v-model="cust.vat_identication" placeholder="Numéro TVA Intracommunautaire">
                        </div>
                        <div class="mcf-page-editor-column-text">
                            <label>Numéro de compte comptable</label>
                            <input type="text" v-model="cust.account_number" placeholder="Numéro de compte comptable">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import {DateTime} from "luxon";

export default {
    props:{
        account:Object,
        customer:Object,
        cancel:Function,
        save:Function
    },
    data(){
        return {
            cust: this.customer
        };
    },
    created() {
        
    },
    methods:{
        bt_cancel:function(){
            this.cancel();
        },
        bt_save:function(){
            if (this.cust.terms_delay=='TERM_RECEIPT'){
                this.cust.terms_nb = 0;
            }
            if (this.cust.terms_delay!='TERM_ENDOFMONTHTO'){
                this.cust.terms_day_due = 0;
            }
            this.save(this.cust);
        },
        set_copy_addresses: function(){
            var tmain = this;
            tmain.cust.billingcompany = tmain.cust.company;
            tmain.cust.billingaddress1 = tmain.cust.address1;
            tmain.cust.billingaddress2 = tmain.cust.address2;
            tmain.cust.billingaddress3 = tmain.cust.address3;
            tmain.cust.billingzipcode = tmain.cust.zipcode;
            tmain.cust.billingcity = tmain.cust.city;
            tmain.cust.billingcountry = tmain.cust.country;
            tmain.cust.billingphone = tmain.cust.phone;
            tmain.cust.deliverycompany = tmain.cust.company;
            tmain.cust.deliveryaddress1 = tmain.cust.address1;
            tmain.cust.deliveryaddress2 = tmain.cust.address2;
            tmain.cust.deliveryaddress3 = tmain.cust.address3;
            tmain.cust.deliveryzipcode = tmain.cust.zipcode;
            tmain.cust.deliverycity = tmain.cust.city;
            tmain.cust.deliverycountry = tmain.cust.country;
            tmain.cust.deliveryphone = tmain.cust.phone;
        },
        set_copy_auto: function() {
            var tmain = this;
            tmain.cust.billingcompany = tmain.cust.billingcompany=='' ? tmain.cust.company : tmain.cust.billingcompany;
            tmain.cust.billingaddress1 = tmain.cust.billingaddress1=='' ? tmain.cust.address1 : tmain.cust.billingaddress1
            tmain.cust.billingaddress2 = tmain.cust.billingaddress2=='' ? tmain.cust.address2 : tmain.cust.billingaddress2;
            tmain.cust.billingaddress3 = tmain.cust.billingaddress3=='' ? tmain.cust.address3 : tmain.cust.billingaddress3;
            tmain.cust.billingzipcode = tmain.cust.billingzipcode=='' ? tmain.cust.zipcode : tmain.cust.billingzipcode;
            tmain.cust.billingcity = tmain.cust.billingcity=='' ? tmain.cust.city : tmain.cust.billingcity;
            tmain.cust.billingcountry = tmain.cust.billingcountry=='' ? tmain.cust.country : tmain.cust.billingcountry;
            tmain.cust.billingphone = tmain.cust.billingphone=='' ? tmain.cust.phone : tmain.cust.billingphone;
            tmain.cust.deliverycompany = tmain.cust.deliverycompany=='' ? tmain.cust.company : tmain.cust.deliverycompany;
            tmain.cust.deliveryaddress1 = tmain.cust.deliveryaddress1=='' ? tmain.cust.address1 : tmain.cust.deliveryaddress1
            tmain.cust.deliveryaddress2 = tmain.cust.deliveryaddress2=='' ? tmain.cust.address2 : tmain.cust.deliveryaddress2;
            tmain.cust.deliveryaddress3 = tmain.cust.deliveryaddress3=='' ? tmain.cust.address3 : tmain.cust.deliveryaddress3;
            tmain.cust.deliveryzipcode = tmain.cust.deliveryzipcode=='' ? tmain.cust.zipcode : tmain.cust.deliveryzipcode;
            tmain.cust.deliverycity = tmain.cust.deliverycity=='' ? tmain.cust.city : tmain.cust.deliverycity;
            tmain.cust.deliverycountry = tmain.cust.deliverycountry=='' ? tmain.cust.country : tmain.cust.deliverycountry;
            tmain.cust.deliveryphone = tmain.cust.deliveryphone=='' ? tmain.cust.phone : tmain.cust.deliveryphone;           
        }
    }
}
</script>